import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getMonthlyPayroll = async ({ companyCode, month, year }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.MonthlyPayrollDetails}?companyCode=${companyCode}&Month=${month}&Year=${year}`
  );
  return data;
};

export const useGetPayrollDetailsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.MonthlyPayrollDetails],
    queryFn: () => getMonthlyPayroll(input),
    refetchOnWindowFocus: false,
  });
};

const getPayroll = async ({ companyCode, locationCode, refNo, employeeCode }) => {

  if( companyCode && locationCode)  {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetPayrollDetails}?companyCode=${companyCode}&RefNo=${refNo}&Employee=${employeeCode}&LocationCode=${locationCode}`
    );
    return data;
  }
  return [];
};

export const useGetPayrollDetailQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetPayrollDetails],
    queryFn: () => getPayroll(input),
    refetchOnWindowFocus: false,
  });
};
